import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { rolesList_template } from "../components/templates/rolesList_template";
import { header } from "./header";
import { hideLoadingOverlay, showLoadingOverlay } from "~/utils/listLoading";
export class roles extends vnModule_knockoutJS {
    getModuleName() {
        return "roles";
    }
    buildContent() {
        const zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        if (zoneHeader) {
            const loadedModule = zoneHeader.loadedModule;
            loadedModule.setHeaderTitle("Role List");
        }
        this.rolesListTemplate = new rolesList_template("list", this.viewModel, this);
        return [this.rolesListTemplate.build()];
    }
    fillPage() {
        this.filterList();
    }
    getListResultsElement() {
        return this.rolesListTemplate?.builtTemplate?.querySelector?.("#list-results") ?? null;
    }
    viewRole(id) {
        this.saveViewModule(this.getMemoryViewModel());
        page("/roles/view/" + id);
    }
    addRole() {
        this.saveViewModule(this.getMemoryViewModel());
        page("/roles/add");
    }
    paginationOnPageClick() {
        this.filterList();
    }
    rolesListReorder() {
        this.filterList();
    }
    filterSimpleOnChange() {
        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }
    filterSimpleCancel() {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }
    }
    getMemoryViewModel() {
        return this.rolesListTemplate.getTemplateViewModel();
    }
    filterList() {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }
        const listResults = this.getListResultsElement();
        if (listResults) {
            showLoadingOverlay(listResults, "Loading roles...");
        }
        const usrReq_url = "/api/roles/get/";
        const usrReq_params = [];
        usrReq_params.push(["data", ko.toJSON(this.rolesListTemplate.getViewModelForRequest())]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onFilterRequestReturn;
        this.XHRHdl.execute();
    }
    onFilterRequestReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                if (req.request.status == 200) {
                    const responseParsed = JSON.parse(req.request.response);
                    obj.updateList(responseParsed);
                }
            });
            const listResults = obj.getListResultsElement();
            if (listResults) {
                hideLoadingOverlay(listResults);
            }
        };
    }
    updateList(responseParsed) {
        if (responseParsed.extraData) {
            this.updateExtraData(responseParsed.extraData);
        }
        this.rolesListTemplate.setRoles(responseParsed.data);
        const execTime = Math.round((new Date().getTime() - this.XHRHdl.requestStartTime) / 1000 * 100) / 100;
        this.rolesListTemplate.setResultInfo(responseParsed.totalCount, responseParsed.totalPage, execTime);
        this.rolesListTemplate.setPaginationTotalCount(responseParsed.totalCount);
    }
    updateExtraData(extraData) {
        this.rolesListTemplate.isAddButtonVisible(extraData.canAdd ? true : false);
    }
}
